import { m } from 'framer-motion';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Container, Typography, Grid } from '@mui/material';
//
import { TextAnimate, MotionContainer, varFade } from '../../components/animate';

// ----------------------------------------------------------------------

const CONTACTS = [
  {
    country: 'Azerbaycan Office',
    address: 'Baki Şehəri, Ziya Bünyadov Prospekti, 1965-ci Mahalle ‘’ Çınar Park ‘’ 503- A Blok Baku, Azerbaijan ',
  },
  {
    country: 'Turkiye Office',
    address: 'Kuştepe, Mecidiyeköy Yolu Cd. No:12,Kat 4 daire 405 34381 Şişli/İstanbul',

  },
  {
    country: 'China Office',
    address: ' No 1619 Centralة , Jianshe Da RD Yuexiu District Guangzhou China',

  },



];



const ContentStyle = styled('div')(({ theme }) => ({
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
    position: 'absolute',
    bottom: theme.spacing(10),
  },
}));

// ----------------------------------------------------------------------

export default function ImageV1() {

    const RootStyle = styled('div')(({ theme }) => ({
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundImage:
          'url(http://morrex.org/imgs/s3/99.jpg)',
        padding: theme.spacing(10, 0),
        [theme.breakpoints.up('md')]: {
          height: 560,
          padding: 0,
        },
      }));

  return (
    <RootStyle>
      <Container component={MotionContainer} sx={{ position: 'relative', height: '100%' }}>
        <ContentStyle>
          <TextAnimate text='Contact Us' sx={{ color: 'primary.main' }} variants={varFade().inRight} />
          <br />
          <Box sx={{ display: 'inline-flex', color: 'common.white' }}>
            <TextAnimate text="to" sx={{ mr: 2 }} />
            <TextAnimate text="find" sx={{ mr: 2 }} />
            <TextAnimate text="us?" />
          </Box>

          <Grid container spacing={2} sx={{ mt: 3, color: 'common.white' }}>
            {CONTACTS.map((contact) => (
              <Grid key={contact.country} item xs={12} sm={12} md={6} lg={4} sx={{ pr: { md: 5 } }}>
                <m.div variants={varFade().in}>
                  <Typography variant="h6" paragraph>
                    {contact.country}
                  </Typography>
                </m.div>
                <m.div variants={varFade().inRight}>
                  <Typography variant="body2">
                    {contact.address}
                    <br /><br /> {contact.email}
                    <br /><br /> {contact.phoneNumber}
                  </Typography>
                </m.div>
                
              </Grid>
            ))}
          </Grid>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
